module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADESURBVEhL5ZO9CQJBEIVPxNQODEytwhqsxybEOixBDvxpwNQCjARjE31vzwcT7OotM0b3wQczK/NecjaD4QxfBU/QTS7Y6qYUFF4wTVsH5/CCO1x/5BxWsIQtVKDkG38Lg2EKDw22qMCFQvqq/4L2IvaoVmLnLPagVmLnLPagVmLnr9jDPh4h0f6TBbxBHezhDIaygyqY8wE84KYb/VygCkZ8AAd4hZO0OXlCFYgV3MJx2pwo3BaE8vcCfnoM1yc4SJrmDVN0khR7AjZdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-paint-sprayer/dark/24.png
// module id = 2316
// module chunks = 2